// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getUndoRegistrationHistory} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateProductDetails} from '../../../product/details/action-creators/product-details';

export const undoRegistration = registration =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await getUndoRegistrationHistory(registration);

            successAlertBar(translate('UNDO_REGISTRATION_SUCCESSFULL'));

            const pin = registration.id.split('-');

            updateProductDetails(pin[0])(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/undo-registration-history.js